export default __webpack_public_path__ + "static/light-mode-cat-f4366528ec7cf6d43a949170c61afeac.png";